import { render, staticRenderFns } from "./MovePanel.vue?vue&type=template&id=60518248&scoped=true"
import script from "./MovePanel.vue?vue&type=script&lang=js"
export * from "./MovePanel.vue?vue&type=script&lang=js"
import style0 from "./MovePanel.vue?vue&type=style&index=0&id=60518248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60518248",
  null
  
)

export default component.exports